import React from "react";
import Marquee from "react-fast-marquee";
import { MapPin, ShieldCheck, ClipboardList, UserRound } from "lucide-react";

const ITEMS = [
  { icon: MapPin, label: "Made in India" },
  { icon: ShieldCheck, label: "Secure Checkout" },
  { icon: ClipboardList, label: "Free Diet Plan" },
  { icon: UserRound, label: "Coach Support" },
  { icon: ShieldCheck, label: "App Access" },
];

export const TrustMarquee = () => {
  return (
    <section
      data-testid="trust-marquee"
      className="border-y border-white/5 bg-black/20 py-6"
    >
      <Marquee speed={35} gradient gradientColor="#020E08" gradientWidth={80} autoFill>
        {ITEMS.map((it, i) => (
          <div key={i} className="flex items-center gap-3 mx-10">
            <it.icon className="h-4 w-4 text-gold" strokeWidth={1.5} />
            <span className="uppercase tracking-[0.25em] text-sm text-white/70">
              {it.label}
            </span>
            <span className="text-gold/40 ml-10">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
